import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdAnalytics, MdArrowCircleRight, MdElderly, MdHomeRepairService, MdLocalHospital, MdPsychology, MdSchool, MdWork } from "react-icons/md";
import { FaTruckMoving } from "react-icons/fa";

export default function Programs(props) {
	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		setReady(true);
	}, []);

	if (!ready) {
		return <div className="container mSupportLoading">{getInlineLoader()}</div>;
	}

	return (
		<div
			className="MainBodySection bg-surface"
			style={{ paddingTop: "50px", paddingBottom: "50px" }}
		>
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							OUR PROGRAMS
						</h6>
						<h5 className="text-muted font-bold">
							Beyond MVC sponsorship, TCHI implements multi-sectoral programs that address the holistic needs of vulnerable groups. 
						</h5>
					</div>

					{/* --- NEW SERVICES CARDS SECTION --- */}
					<div className="col-md-12 mt-4">
						<div className="row g-3">
							{/* Project Support Services */}
							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdSchool
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Education & Vocational Training
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Facilitating formal education, vocational skills, and youth empowerment programs that equip children and young people with knowledge and employable skills.
									</h6>
								</div>
							</div>

							{/* Transport & Logistics Services */}
							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdLocalHospital
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Health & Nutrition
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Implementing maternal and child health initiatives, nutrition programs, and HIV prevention and care services to improve overall well-being.
									</h6>
								</div>
							</div>

							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdPsychology
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Psychosocial Support
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Offering counseling, mentoring, and community-based support to address emotional and social challenges faced by children, adolescents, and families.
									</h6>
								</div>
							</div>

							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdWork
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Women’s Economic Empowerment
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Enhancing women’s financial independence through entrepreneurship training, income-generating projects, and sustainable livelihood programs.
									</h6>
								</div>
							</div>

							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdElderly
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Elderly Care
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Providing support for the elderly through social inclusion initiatives, health interventions, and community engagement programs.
									</h6>
								</div>
							</div>

							<div className="col-md-6">
								<div
									className="card shadow-sm p-2"
									style={{
										borderRadius: "12px",
										background: "white",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
									}}
								>
									<div className="d-flex gap-3 align-items-center p-3">
										<MdAnalytics
											size={64}
											color="var(--secondaryColor)"
											className="flex-shrink-0"
										/>
										<h5 className="text-primary font-bold">
											Research, Monitoring & Evaluation
										</h5>
									</div>
									<h6 className="text-muted p-3 bg-primary rounded lh-lg" style={{textAlign:"justify"}}>
										Strengthening data collection, program assessment, and evidence-based strategies for effective and sustainable interventions.
									</h6>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
